module.exports = __webpack_public_path__ + "static/img/tit2.b8186859.png";